<template>
  <div class="h-dialogContainer">
    <!--<div class="h100vh-116">-->
<!--
    <GroupMemberTableMenu @methodEnum='methodEnum'></GroupMemberTableMenu>
-->
    <!--</div>-->
    <div class="h100vh-435">
      <ejs-grid ref='grid' :dataSource="data" :allowResizing='true' :pageSettings="page" height="calc(100% - 0px)">
        <e-columns>
<!--
          <e-column type='checkbox' headerText='职员编号' width='40' textAlign='Center'></e-column>
-->
          <e-column field='staffnum' :headerText="$t('SubscriberIms.staffId')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='staffname' :headerText="$t('SubscriberIms.staffName')" width='110' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='platenum' :headerText="$t('SubscriberIms.licenseNum')" width='180' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='udn' :headerText="$t('SubscriberIms.subNum')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='post' :headerText="$t('SubscriberIms.profession')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='worktype' :headerText="$t('SubscriberIms.post')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='unitname' :headerText="$t('SubscriberIms.unitName')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='unitcode' :headerText="$t('SubscriberIms.unitCode')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='telnum' :headerText="$t('SubscriberIms.mobile')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='usetype' :headerText="$t('SubscriberIms.use')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='terminaltype' :formatter='rtttypeFormat' :headerText="$t('SubscriberIms.terType')" width='100' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
        </e-columns>
      </ejs-grid>
      <ejs-pager ref="grpPager" @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
  </div>
</template>

<script>
  import GroupMemberTableMenu from '../GroupMemberTableMenu';
  import CustomDialog from '../../../../common/CustomDialog';
  import MemberInfoCommon from '../../MemberInfoCommon';

  export default {
    name: 'StaffInfo',
    components: {
      CustomDialog,
    },
    props: [
      'neid',
      'node',
    ],
    data() {
      return {
        data: {},
        userData: [],
        impu: '',
        vpnid:'',
        taskMsgid: {
          qryStaffInfoMsgid: '27841', // 查询隶属关系命令吗
        },
        page: {
          pageNo: 1,
          pageSize: 25,
          totalCount: 0,
          pageCount: 0,
        },
        info: {
          msgid: '',
          neid: this.neid,
        },
        vo: {
          flag: '',
          participantType: ''
        },
        dialog: {
          tipInfos: '',
          styles: {
            width: '45%',
            height: '50%',
            visible: false,
            model: true
          },
        },
        gridTypeEnum: {
          rtttype: [,,this.$t('SubscriberIms.rtttype2'),,this.$t('SubscriberIms.rtttype4'),this.$t('SubscriberIms.rtttype5'),this.$t('SubscriberIms.rtttype6'),,this.$t('SubscriberIms.rtttype8')]
        }
      };
    },
    methods: {
      getGridData(vpnid,vpnclass) {
        const $this =this;
        $this.vpnid = vpnid;
        $this.page.pageNo = $this.$refs.grpPager.ej2Instances.currentPage ? $this.$refs.grpPager.ej2Instances.currentPage : 1;

        const param = {
          vo: { flag: 0,vpnid:vpnid,vpnClass:vpnclass },
          info: { msgid: this.taskMsgid.qryStaffInfoMsgid, neid: this.neid },
          page: this.page
        };
        this.$axios.post('/lte/ems/subscriber/imsunms/requestCommon', param).then((response) => {
          const res = response.data.resultVal;
          if (res.resultList) {
            $this.data = res.resultList;
            $this.page.pageCount = res.page;
            $this.page.totalCount = res.countrsp;
            $this.page.pageCount = Math.ceil(res.countrsp / $this.page.pageSize);
          }
        });
      },
      getCheckedData() {
        let selectedRecords = this.$refs.grid.getSelectedRecords();
        if(selectedRecords.length == 1)
          return selectedRecords[0].staffname;
        else
          return null;
      },
      rtttypeFormat(grids,data){
        return this.gridTypeEnum.rtttype[data.terminaltype];
      },
    }
  };
</script>

<style scoped>

</style>
